<div class="chatbot-composer d-flex flex-column gap-2 p-3 border-top border-light border-opacity-10">
  <div
    v-if="show_compare_selector"
    class="w-100"
    :class="{ 'is-open': is_compare_drawer_open }"
  >
    <button
      type="button"
      class="btn btn-sm w-100 d-flex align-items-center justify-content-between px-3 py-2 border border-light border-opacity-10 rounded-3 text-white text-xs chatbot-soft-bg"
      :disabled="disabled"
      :aria-expanded="is_compare_drawer_open ? 'true' : 'false'"
      aria-controls="chatbot-compare-drawer-panel"
      @click="toggle_compare_drawer"
    >
      <span class="d-inline-flex align-items-center gap-2">
        <i class="bi bi-buildings" aria-hidden="true"></i>
        <span>Properties</span>
      </span>
      <span class="d-inline-flex align-items-center gap-2">
        <span class="text-white-50">{{ selected_compare_property_count_label }}</span>
        <i :class="is_compare_drawer_open ? 'bi bi-chevron-down' : 'bi bi-chevron-up'" aria-hidden="true"></i>
      </span>
    </button>

    <div
      v-if="is_compare_drawer_open"
      id="chatbot-compare-drawer-panel"
      class="mt-2 p-2 border border-light border-opacity-10 rounded-3 chatbot-soft-bg"
    >
      <div class="d-flex align-items-center justify-content-between gap-2 mb-2 text-xs text-white-50">
        <span>{{ selected_compare_property_summary }}</span>
        <span class="d-inline-flex align-items-center gap-1">
          <button
            type="button"
            class="btn btn-sm btn-outline-light rounded-pill py-0 px-2 text-xs"
            :disabled="disabled || all_compare_properties_selected"
            @click="select_all_compare_properties"
          >
            All
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-light rounded-pill py-0 px-2 text-xs"
            :disabled="disabled || !normalized_compare_property_ids().length"
            @click="clear_compare_properties"
          >
            Clear
          </button>
        </span>
      </div>

      <div class="row row-cols-2 g-1 overflow-auto chatbot-compare-property-grid">
        <div
          v-for="property in compare_property_options"
          :key="property.id"
          class="col"
        >
          <label
            class="d-flex align-items-center gap-2 px-2 py-1 rounded-2 text-xs chatbot-compare-property-option"
            :class="{ 'bg-white bg-opacity-10': is_compare_property_selected(property.id) }"
            role="button"
            :for="`compare-property-${property.id}`"
          >
            <input
              class="form-check-input m-0"
              type="checkbox"
              :id="`compare-property-${property.id}`"
              :checked="is_compare_property_selected(property.id)"
              :disabled="disabled"
              @change="toggle_compare_property(property.id)"
            />
            <span>{{ property.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="chatbot-input-shell d-flex align-items-center gap-2 w-100 rounded-pill border border-light border-opacity-10 ps-3 pe-1 py-1">
    <input
      type="text"
      :value="model_value"
      :disabled="disabled"
      @input="$emit('update:model_value', $event.target.value)"
      @keyup.enter="$emit('send')"
      class="form-control form-control-sm bg-transparent text-white border-0 shadow-none px-0 chatbot-input"
      :placeholder="placeholder"
      aria-label="Message AI Campus VSI"
    />

    <button
      type="button"
      class="btn btn-primary rounded-circle d-inline-flex align-items-center justify-content-center p-0 flex-shrink-0 chatbot-send-btn"
      :disabled="disabled || !model_value.trim()"
      @click="$emit('send')"
      aria-label="Send message"
    >
      <i class="bi bi-arrow-up"></i>
    </button>
  </div>
</div>
